export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./JobDetail.vue?vue&type=template&id=1a5161e6&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Index/JobDetail.vue?vue&type=template&id=1a5161e6&
// module id = null
// module chunks = 